import React, {createContext, useContext} from 'react';

export const MiniSiteDetectContext = createContext(false);

export const useMiniSiteDetect = () => useContext(MiniSiteDetectContext)
